import React from 'react'

import hlBlue from '@images/overlays/hl_blue.svg'
import hlBlueBlock from '@images/overlays/hl_blue_block.jpg'
import hlGreen from '@images/overlays/hl_green.svg'
import hlGreenBlock from '@images/overlays/hl_green_block.jpg'
import hlGrey from '@images/overlays/hl_grey.svg'
import hlGreyBlock from '@images/overlays/hl_grey_block.jpg'
import hlPurple from '@images/overlays/hl_purple.svg'
import hlPurpleBlock from '@images/overlays/hl_purple_block.jpg'
import hlRed from '@images/overlays/hl_red.svg'
import hlRedBlock from '@images/overlays/hl_red_block.jpg'
import hlYellow from '@images/overlays/hl_yellow.svg'
import hlYellowBlock from '@images/overlays/hl_yellow_block.jpg'

interface Props {
  directive?: string | null
}
const CoverArtOverlay: React.FC<Props> = ({ directive }: Props) => {
  if (!directive) return null

  let svg: any
  let className = 'absolute bottom-[-1px] left-0 right-0'
  const blockClass = 'absolute max-w-none h-full'
  switch (directive) {
    case 'hl_overlay/0':
      svg = hlRed
      break
    case 'hl_overlay/1':
      svg = hlGrey
      break
    case 'hl_overlay/2':
      svg = hlYellow
      break
    case 'hl_overlay/3':
      svg = hlGreen
      break
    case 'hl_overlay/4':
      svg = hlPurple
      break
    case 'hl_overlay/5':
      svg = hlBlue
      break
    case 'hl_overlay/6':
      svg = hlRedBlock
      className = blockClass
      break
    case 'hl_overlay/7':
      svg = hlGreyBlock
      className = blockClass
      break
    case 'hl_overlay/8':
      svg = hlYellowBlock
      className = blockClass
      break
    case 'hl_overlay/9':
      svg = hlGreenBlock
      className = blockClass
      break
    case 'hl_overlay/10':
      svg = hlPurpleBlock
      className = blockClass
      break
    case 'hl_overlay/11':
      svg = hlBlueBlock
      className = blockClass
      break
    default:
      svg = null
  }

  if (!svg) return null
  return <img alt="Overlay" src={svg} className={className} />
}

export default CoverArtOverlay
